export class UserPixKey {
  id?: number;
  pixKey: string;
  pixKeyType: number;
}
